import React, { useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { BlocAppWrapper } from '../bloc/BlocAppWrapper';
import { AppContext, AppShare } from '../../base/AppContext';
import StreamBuilder from './common/StreamBuilder';
import LocalStorage from '../../base/LocalStorage';
import { AdminApp } from './AdminApp';
import GlobalDialogs from './dialogs/GlobalDialogs';
import AdminLoginPage from '../pages/admin/AdminLoginPage';


interface AppWrapperProps {
    blocAppWrapper: BlocAppWrapper;
}

const AppWrapper: React.FC<AppWrapperProps> = ({ blocAppWrapper }) => {
    const location = useLocation();
    const toastRef = useRef(null);

    // useEffect(() => {
    //     const initializeApp = async () => {
    //         try {

    //             // Đánh dấu khởi tạo hoàn thành
    blocAppWrapper.setStream('loadInit', {
        loginRequire: { status: 0, url: '' },
        finish: true,
    });
    //         } catch (error) {
    //             console.error('App initialization failed:', error);
    //             blocAppWrapper.setStream('loadInit', {
    //                 loginRequire: { status: -1, url: '' },
    //                 finish: true,
    //                 error: error,
    //             });
    //         }
    //     };

    //     initializeApp();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [blocAppWrapper]);

    useEffect(() => {
        // Scroll to top khi thay đổi route
        window.scrollTo(0, 0);
    }, [location]);

    // API Handler để xử lý loading, auth, errors - tương tự module-ui
    const handleRequest = {
        showLoading: (isShow: boolean) => {
            blocAppWrapper.setStream('loading', { isShow });
        },
        onUnAuth: () => {
            // Clear tokens và redirect với URL preservation như module-ui
            LocalStorage.deleteToken();
            LocalStorage.delete('refreshToken');
            LocalStorage.delete('userInfo');
            LocalStorage.delete('fullName');

            // Set auth state và redirect
            blocAppWrapper.setStream('loadInit', {
                loginRequire: { status: 1, url: location.pathname },
                finish: true,
            });

            // Hard redirect để đảm bảo clear state
            setTimeout(() => {
                window.location.href = `/login?redirect=${encodeURIComponent(location.pathname)}`;
            }, 100);
        },
        onError: (error: any) => {
            console.error('API Error:', error);

            // Xử lý các lỗi giống module-ui
            if (error.code === 401) {
                // Unauthorized - clear tokens và redirect
                LocalStorage.setItem('token', '');
                LocalStorage.setItem('refreshToken', '');
                LocalStorage.setItem('userInfo', '');
                LocalStorage.setItem('fullName', '');
                window.location.href = '/login';
                return;
            } else if (error.code === 406) {
                // Forbidden - Access denied
                window.location.href = '/access-denied';
                return;
            } else if (error.code === 404) {
                // Not found
                window.location.href = '/404';
                return;
            }

            // Show toast for other errors
            if (toastRef.current) {
                // In thực tế, bạn có thể implement toast system
                console.error('Error:', error.messageKey || error.message);
            }

            // Show alert dialog
            blocAppWrapper.showAlertApi?.(error.messageKey || error.message);
        },
    };

    // Context value cho AppProvider
    const contextValue: AppShare = {
        apiHandler: handleRequest,
        app: blocAppWrapper,
        showAlert: (title: string, message: string, label: string, onCallBack?: ((data: any) => void) | null, dismiss: boolean = true) => {
            blocAppWrapper.getStream('dialogAlert').next({
                isShow: true,
                title,
                message,
                label,
                onCallBack,
                dismiss,
            });
        },
        showConFirm: (title: string, message: string, labelLeft: string = '', labelRight: string = '', onCallBack?: ((data: any) => void) | null, dismiss: boolean = false) => {
            blocAppWrapper.getStream('dialogConfirm').next({
                isShow: true,
                title,
                message,
                labelLeft,
                labelRight,
                onCallBack,
                dismiss,
            });
        },
        showToast: (severity: string, summary: string, message: string) => {
            // Implementation for toast notifications
            console.log(`Toast: ${severity} - ${summary}: ${message}`);
        },
        portScan: 8080,
        currentBloc: null,
        toastBR: toastRef, // Add this property
        dateTimeFormat: {
            dateFormat: 'YYYY-MM-DD',
            dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
            timeFormat: 'HH:mm:ss',
            calendarViewDate: 'yy/mm/dd',
            calendarViewDateTime: 'yy/mm/dd HH:mm',
            timeDateFormat: 'HH:mm:ss YYYY-MM-DD',
        },
    };

    return (
        <div>
            <StreamBuilder
                initialData={{ loginRequire: { status: 0, url: '' }, finish: false }}
                stream={blocAppWrapper.getStream('loadInit')}
                builder={(snapshot) => (
                    <AppContext.Provider value={contextValue}>
                        <Routes>
                            {/* Admin Routes - độc lập*/}
                            <Route path="/admin/*" element={<AdminApp />} />

                            {/* Default redirect to admin login */}
                            <Route path="/" element={<Navigate to="/admin/login" replace />} />

                            {/* Error Pages */}
                            <Route path="/404" element={<div className="text-center p-8"><h1>404 - Page Not Found</h1></div>} />
                            <Route path="/access-denied" element={<div className="text-center p-8"><h1>Access Denied</h1></div>} />

                            {/* Catch all other routes and redirect to admin login */}
                            <Route path="*" element={<Navigate to="/admin/login" replace />} />
                        </Routes>
                    </AppContext.Provider>
                )}
            />
            {/* Global Dialogs - tương tự module-ui */}
            <GlobalDialogs />
        </div>
    );
};

export default AppWrapper;
